/* eslint-disable no-confusing-arrow */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable object-curly-newline */
/* eslint-disable no-lonely-if */
/* eslint-disable no-useless-return */
/* eslint-disable no-trailing-spaces */
/* eslint-disable consistent-return */
/* eslint-disable default-case */

import React from 'react';

import {
 LuggageIcon,
 SeatAvailableLegendIcon,
 SeatIcon,
 SeatUnavailableLegendIcon,
 SelectedSeatLegendIcon,
 TableIcon,
 ToiletIcon,
 ExitIcon,
 SingleBoldArrowIcon,
 StairsIconDown,
 StairsIconUp,
 WheelchairIcon,
 BusinessPremierIndicator,
} from '../Icons';
import { SeatMapHorizontalLegend } from './SeatMapHorizontalStyled';
import {
 VerticalSeatMap,
 SeatMapVerticalLegend,
 VerticalSeatMapWrapper,
 SeatMapTransformWrapper,
 VerticalSeatMapDirection,
 FakeVerticalSeatMapWrapper,
 SeatVerticalSchema,
} from './SeatMapVerticalStyled';
import {
 Cell,
 ExitWrapper,
 IconWrapper,
 Other,
 SeatId,
 SeatMapIconWrapper,
 SeatSchema,
 SeatSchemaContainer,
 WheelchairId,
 WheelchairWrapper,
} from './SeatMapStyled';
import { DeckLevelType, LayoutItemType, SeatMapVariant, SeatType, StatusType } from '../seatMapConstants';

const SeatMap = ({
 deck,
 selectedSeats,
 setSelectedSeats,
 maxSeats = 1,
 seatMapLabels,
 deckLevel,
 variant,
 scaleFactor = 1,
 isBusinessPremierDeck,
 ...rest
}) => {
  const isOther = (type) => (
    LayoutItemType.LUGGAGERACK === type 
    || LayoutItemType.BATHROOM === type 
    || LayoutItemType.STAIRS === type 
    || LayoutItemType.LUGGAGEROOM === type
  );

  const renderSeatIcon = (cell) => {
    const { status, id, direction, type } = cell;
    const isAvailable = status === StatusType.FREE;
    const isSelected = selectedSeats.some((seat) => seat.id === id);

    switch (type) {
      case SeatType.SEAT:
      case SeatType.SHELF: {
        return (
         <IconWrapper
           isAvailable={isAvailable}
           isSelected={isSelected}
           variant={variant}
         >
         {isAvailable && <SeatId className="seatId">{id}</SeatId>}
           <SeatMapIconWrapper
             isAvailable={isAvailable}
             direction={direction}
             isSelected={isSelected}
           >
            <SeatIcon scaleFactor={scaleFactor} />
           </SeatMapIconWrapper>
         </IconWrapper>
        );
      }
     case SeatType.WHEELCHAIR: {
        return (
         <IconWrapper isAvailable={isAvailable} isSelected={isSelected}>
             {isAvailable && (
               <WheelchairId isSelected={isSelected} direction={direction}>
                {id}
               </WheelchairId>
             )}
            <WheelchairWrapper
              isAvailable={isAvailable}
              direction={direction}
              isSelected={isSelected}
            >
             <WheelchairIcon />
            </WheelchairWrapper>
         </IconWrapper>
        );
     }
    }
  };

  const renderLayoutIcon = (layoutItemtype) => {
    switch (layoutItemtype) {
      case LayoutItemType.TABLE:
        return <TableIcon scaleFactor={scaleFactor} />;

      case LayoutItemType.STAIRS:
        return deckLevel === DeckLevelType.UPPER ? <StairsIconDown scaleFactor={scaleFactor} /> : (
                 <StairsIconUp scaleFactor={scaleFactor} />
              );
     case LayoutItemType.LUGGAGEROOM:
        return <LuggageIcon scaleFactor={scaleFactor} />;
     case LayoutItemType.LUGGAGERACK:
        return <LuggageIcon scaleFactor={scaleFactor} />; // TODO: find the icon for the rack

     case LayoutItemType.BATHROOM:
        return <ToiletIcon scaleFactor={scaleFactor} />;
     case LayoutItemType.EXIT:
        return (
          <ExitWrapper>
            <ExitIcon scaleFactor={scaleFactor} />
            <ExitIcon scaleFactor={scaleFactor} />
          </ExitWrapper>
        );

     case LayoutItemType.OTHER:
        return <Other />;
    default:
        return;
    }
   };

  const handleSelectedSeats = (selectedSeat) => () => {
    const isAvailable = selectedSeat.status === StatusType.FREE;
      if (!isAvailable) return;
      if (selectedSeats.some((seat) => seat.id === selectedSeat.id)) {
         const selections = selectedSeats.filter((seat) => seat.id !== selectedSeat.id);
         setSelectedSeats(selections);
      } else if (maxSeats === 1) {
         setSelectedSeats([selectedSeat]);
      } else {
         if (maxSeats > selectedSeats.length) {
          setSelectedSeats([...selectedSeats, selectedSeat]);
         }
       }
  };

  const {
    seats = [],
    layoutItems = [],
    defaultSeatSize = { height: 32, width: 32 },
    floorPlanSize: { height: floorPlanHeight, width: floorPlanWidth },
  } = deck;

  const Legend = () => (
    <ul>
     <li>
      <SelectedSeatLegendIcon />
      <span>{seatMapLabels.selected.label}</span>
     </li>
     <li>
      <SeatAvailableLegendIcon />
      <span>{seatMapLabels.available.label}</span>
     </li>
     <li>
      <SeatUnavailableLegendIcon />
      <span>{seatMapLabels.unavailable.label}</span>
     </li>
    </ul>
  );

  const RenderHorizontalSeatMap = () => (
    <>
     {isBusinessPremierDeck && (<div id="business-premier-wrapper"><BusinessPremierIndicator /></div>)}
     <SeatSchemaContainer width={floorPlanWidth * scaleFactor} className="seatmap-wrapper">
       <SeatSchema height={floorPlanHeight * scaleFactor} width={floorPlanWidth * scaleFactor} {...rest}>
         {seats.map((item) => {
           const { id, position: { x, y } } = item;

           return (
             <Cell
               id={id}
               key={id}
               top={y * scaleFactor}
               left={x * scaleFactor}
               height={defaultSeatSize.height * scaleFactor}
               width={defaultSeatSize.width * scaleFactor}
               onClick={handleSelectedSeats(item)}
             >
              {renderSeatIcon(item)}
             </Cell>
           );
          })}

        {layoutItems.map((layoutItem, index) => {
           const { type, position: { x, y, width, height } } = layoutItem;

            return (
              <Cell
                key={index}
                top={y * scaleFactor + 2}
                left={x * scaleFactor + 2}
                isOther={isOther(type)}
                containExit={type === LayoutItemType.EXIT}
              >
               <IconWrapper height={height * scaleFactor - 4} width={width * scaleFactor - 4}>
                 {renderLayoutIcon(type)}
               </IconWrapper>
              </Cell>
            );
        })}
       </SeatSchema>
     </SeatSchemaContainer>

     <SeatMapHorizontalLegend width={floorPlanWidth * scaleFactor} className="seatmap-legend">
       <Legend />
       <span className="direction">
         {seatMapLabels.direction.label}
         <SingleBoldArrowIcon height={13 * scaleFactor} width={13 * scaleFactor} />
       </span>
     </SeatMapHorizontalLegend>
    </>
   );

   const RenderVerticalSeatMap = () => (
    <VerticalSeatMap>
      <VerticalSeatMapWrapper width={floorPlanHeight * scaleFactor + 10} height={floorPlanWidth * scaleFactor + 40}>
            {isBusinessPremierDeck && (
               <div id="business-premier-wrapper">
                 <BusinessPremierIndicator />
               </div>
            )}

            <VerticalSeatMapDirection>
              {seatMapLabels.direction.label}
              <SingleBoldArrowIcon height={12} width={12} />
            </VerticalSeatMapDirection>

            <FakeVerticalSeatMapWrapper width={floorPlanHeight * scaleFactor + 10} height={floorPlanWidth * scaleFactor} />
              <SeatMapTransformWrapper>
                <SeatSchemaContainer
                  height={floorPlanHeight * scaleFactor}
                  width={floorPlanWidth * scaleFactor}
                  className="seatmap-wrapper"
                >
                  <SeatVerticalSchema
                     height={floorPlanHeight * scaleFactor}
                     width={floorPlanWidth * scaleFactor}
                    {...rest}
                  >
                    {seats.map((item) => {
                       const { id, position: { x, y } } = item;

                       return (
                           <Cell
                             id={id}
                             key={id}
                             top={y * scaleFactor}
                             left={x * scaleFactor}
                             height={defaultSeatSize.height * scaleFactor}
                             width={defaultSeatSize.width * scaleFactor}
                             onClick={handleSelectedSeats(item)}
                           >
                            {renderSeatIcon(item)}
                           </Cell>
                        );
                    })}

                    {layoutItems.map((layoutItem, index) => {
                       const { type, position: { x, y, width, height } } = layoutItem;

                       return (
                           <Cell
                             key={index}
                             top={y * scaleFactor + 2}
                             left={x * scaleFactor + 2}
                             isOther={isOther(type)}
                             containExit={type === LayoutItemType.EXIT}
                           >
                                  <IconWrapper
                                     height={height * scaleFactor - 4}
                                     width={width * scaleFactor - 4}
                                     data-type={type}
                                  >
                                    {renderLayoutIcon(type)}
                                  </IconWrapper>
                           </Cell>
                        );
                    })}
                  </SeatVerticalSchema>
                </SeatSchemaContainer>
              </SeatMapTransformWrapper>
      </VerticalSeatMapWrapper>
          <SeatMapVerticalLegend>
             <Legend />
          </SeatMapVerticalLegend>
    </VerticalSeatMap>
  );

  return variant === SeatMapVariant.HORIZONTAL ? <RenderHorizontalSeatMap /> : <RenderVerticalSeatMap />;
};

export default SeatMap;
